function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBemerkung = function SvgBemerkung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 1 0 9 9 9.026 9.026 0 0 0-9-9Zm.9 13.5H8.1v-1.8h1.8Zm0-3.6H8.1V4.5h1.8Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgBemerkung;